import Configurator, { EnvironmentType } from './Configurator';

const configuration = new Configurator();

const { setEnv, getConfig, override } = configuration;

export type { EnvironmentType };

export { setEnv, getConfig, override };
